import { Directive, ElementRef, HostListener, OnInit, inject } from '@angular/core';

@Directive({
  selector: '[mytcLazyImage]',
  exportAs: 'mytcLazyImage',
  standalone: false,
})
export class LazyImageDirective implements OnInit {
  private elementRef = inject(ElementRef);

  isLoaded = false;
  isLoadFailed = false;

  @HostListener('load') onLoad(): void {
    this.isLoaded = true;
    this.isLoadFailed = false;
  }

  @HostListener('error') onError(): void {
    this.isLoadFailed = true;
    this.isLoaded = false;
  }

  ngOnInit(): void {
    if (this.elementRef.nativeElement instanceof HTMLImageElement) {
      this.elementRef.nativeElement.loading = 'lazy';
    }
  }
}
